<template>
	<div>
		<div class="view-title">
			{{ detail.info.project_name }}
			<el-tooltip class="item" effect="dark" :content="attrText.defaultWorkgroup" placement="top" v-if="detail.info.network_id">
				<i class="fa fa-globe" aria-hidden="true"></i>
			</el-tooltip>
		</div>
		<div class="workgroup-wrapper" v-if="detail.info">
			<el-tabs type="card" :active-name="detail.currentTab" @tab-click="onTabClick">
				<!--操作头部-->
				<div class="add-ssk" v-if="!detail.info.network_id && $route.query.type !== 'member' && $route.query.type !== 'group'">
					<el-button type="text" @click.stop="onShowWorkgroupDistributeInstance()">
						<i class="fa fa-plus fa-lg"></i>
						<translate>Add</translate>
					</el-button>
					<el-button type="text" @click="batchDel(null, detail.batchDel)" v-if="!detail.info.network_id" :disabled="detail.batchDel === ''">
						<i class="fa fa-trash fa-lg"></i>
						<translate>Delete</translate>
					</el-button>
				</div>
				<!--tab 栏-->
				<el-tab-pane :label="attrText.servers" name="ecs">
					<el-table v-loading="loading" :data="detail.list" style="width: 100%" :row-class-name="tableRowClassName" @selection-change="onSelectionChange" v-if="detail.info && detail.list && detail.currentTab === 'ecs' && !loading">
						<el-table-column type="selection" width="30" v-if="detail.isHaveNet"></el-table-column>
						<el-table-column :label="attrText.name">
							<template scope="scope">
								<span>{{ scope.row.name }}</span>
							</template>
						</el-table-column>
						<el-table-column label="IP">
							<template scope="scope">
								{{ scope.row.ip }}
							</template>
						</el-table-column>
						<el-table-column :label="attrText.loginUsername">
							<template scope="scope">
								{{ scope.row.project_resource_login_username ? JSON.parse(scope.row.project_resource_login_username).login_username.join(';') : '-' }}
							</template>
						</el-table-column>
						<el-table-column :label="attrText.cluster">
							<template scope="scope">
								{{ !detail.info.network_id ? scope.row.network_name : scope.row.project }}
							</template>
						</el-table-column>
						<el-table-column :label="attrText.os">
							<template scope="scope">
								{{ scope.row.type === 'LinuxServer' ? 'Linux' : 'Windows' }}
							</template>
						</el-table-column>
						<el-table-column :label="attrText.Specification" width="100">
							<template scope="scope">
								{{ scope.row.flavor ? scope.row.flavor : '-' }}
							</template>
						</el-table-column>
						<el-table-column :label="attrText.action" width="130">
							<template scope="scope">
								<el-button type="text" @click="batchChange(scope.row)">
									<translate>Change</translate>
								</el-button>
								<el-button v-if="detail.isHaveNet" type="text" :loading="scope.row.loading" @click="batchDel(scope.row, scope.row.id)">
									<translate v-if="!scope.row.loading">Delete</translate>
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="pagination" v-if="detail.totalPage > 10 && detail.currentTab === 'ecs'">
						<el-pagination layout="total, prev, pager, next" :total="detail.totalPage" :current-page.sync="detail.currentPage" :page-size="10" @current-change="onChangePage"></el-pagination>
					</div>
				</el-tab-pane>
				<!--数据库tab-->
				<el-tab-pane :label="attrText.dataBase" name="rds">
					<el-table v-loading="loading" :data="detail.list" style="width: 100%" :row-class-name="tableRowClassName" @selection-change="onSelectionChange" v-if="detail.info && detail.list && detail.currentTab === 'rds' && !loading">
						<el-table-column type="selection" width="30" v-if="detail.isHaveNet"></el-table-column>
						<el-table-column :label="attrText.name">
							<template scope="scope">
								<span>{{ scope.row.name }}</span>
							</template>
						</el-table-column>
						<el-table-column :label="attrText.dataBaseName">
							<template scope="scope">
								{{ scope.row.db_name ? scope.row.db_name.join('; ') : '' }}
							</template>
						</el-table-column>
						<el-table-column :label="attrText.ipConnect">
							<template scope="scope">
								{{ scope.row.ip }}
							</template>
						</el-table-column>
						<el-table-column :label="attrText.cluster">
							<template scope="scope">
								{{ detail.isHaveNet ? scope.row.network_name : scope.row.project }}
							</template>
						</el-table-column>
						<el-table-column :label="attrText.type" width="120">
							<template scope="scope">
								<span v-if="scope.row.type == 'PostgreSQLDatabase'">PostgreSQL</span>
								<span v-else-if="scope.row.type == 'MySQLDatabase'">MySQL</span>
								<span v-else-if="scope.row.type == 'OracleDatabase'">Oracle</span>
								<span v-else>SQL Server</span>
							</template>
						</el-table-column>
						<el-table-column :label="attrText.action" width="100" v-if="detail.isHaveNet">
							<template scope="scope">
								<el-button type="text" :loading="scope.row.loading" @click="batchDel(scope.row, scope.row.id)">
									<translate v-if="!scope.row.loading">Delete</translate>
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="pagination" v-if="detail.totalPage > 10 && detail.currentTab === 'rds'">
						<el-pagination layout="total, prev, pager, next" :total="detail.totalPage" :current-page.sync="detail.currentPage" :page-size="10" @current-change="onChangePage"></el-pagination>
					</div>
				</el-tab-pane>
				<!--成员tab-->
				<el-tab-pane :label="attrText.members" name="member">
					<div class="add-ssk">
						<el-button type="text" @click.stop="onShowWorkgroupAddMember(detail.members)">
							<i class="fa fa-graduation-cap fa-lg"></i>
							<translate>Distribute</translate>
						</el-button>
						<el-button type="text" @click="batchDel(null, detail.batchDel)" :disabled="detail.batchDel === '' || loading">
							<i class="fa fa-trash fa-lg"></i>
							<translate>Delete</translate>
						</el-button>
					</div>
					<el-table ref="memberTable" v-loading="loading" :data="detail.members" style="width: 100%" :row-class-name="tableRowClassName" @selection-change="onSelectionChange">
						<el-table-column type="selection" width="30"></el-table-column>
						<el-table-column :label="attrText.name">
							<template scope="scope">
								<span>{{ scope.row.name }}</span>
							</template>
						</el-table-column>
						<el-table-column :label="attrText.account">
							<template scope="scope">
								{{ scope.row.account }}
							</template>
						</el-table-column>
						<el-table-column :label="attrText.type">
							<template scope="scope">
								{{ scope.row.is_admin ? attrText.administrator : attrText.ordinary }}
							</template>
						</el-table-column>
						<el-table-column :label="attrText.action" width="180">
							<template scope="scope">
								<el-button type="text" :loading="scope.row.loading" @click="batchDel(scope.row, scope.row.id)">
									<translate v-if="!scope.row.loading">Delete</translate>
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="pagination" v-if="detail.totalPage > 10 && detail.currentTab === 'member'">
						<el-pagination layout="total, prev, pager, next" :total="detail.totalPage" :current-page.sync="detail.currentPage" :page-size="10" @current-change="onChangePage"></el-pagination>
					</div>
				</el-tab-pane>
				<!--群组tab-->
				<el-tab-pane :label="attrText.group" name="group">
					<div class="add-ssk">
						<el-button type="text" @click.stop="onShowWorkgroupAddGroup(detail.groups)">
							<i class="fa fa-graduation-cap fa-lg"></i>
							<translate>Distribute</translate>
						</el-button>
						<el-button type="text" @click="batchDel(null, detail.batchDel)" :disabled="detail.batchDel === '' || loading">
							<i class="fa fa-trash fa-lg"></i>
							<translate>Delete</translate>
						</el-button>
					</div>
					<el-table ref="groupTable" v-loading="loading" :data="detail.groups" style="width: 100%" :row-class-name="tableRowClassName" @selection-change="onSelectionChange">
						<el-table-column type="selection" width="30"></el-table-column>
						<el-table-column :label="attrText.name">
							<template scope="scope">
								<span>{{ scope.row.name }}</span>
							</template>
						</el-table-column>
						<el-table-column :label="attrText.action" width="180">
							<template scope="scope">
								<el-button type="text" @click="onShowWorkgroupViewGroup(scope.row)">
									<translate>View</translate>
								</el-button>
								<el-button type="text" :loading="scope.row.loading" @click="batchDel(scope.row, scope.row.id)">
									<translate v-if="!scope.row.loading">Delete</translate>
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="pagination" v-if="detail.totalPage > 10 && detail.currentTab === 'group'">
						<el-pagination layout="total, prev, pager, next" :total="detail.totalPage" :current-page.sync="detail.currentPage" :page-size="10" @current-change="onChangePage"></el-pagination>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>

		<component :is="currentRightPanel" :items="rightPanelData" @onClosePanel="onClosePanel" @callback="callback"></component>
	</div>
</template>

<script>
import STORE_CONST from '../../store/consts'
import WorkgroupDistributeInstance from './model/workgroup-distribute-instance'
import WorkgroupAddMember from './model/workgroup-add-member'
import WorkgroupViewGroup from './model/workgroup-view-group'
import WorkgroupAddGroup from './model/workgroup-add-group'
import WorkgroupChangeHost from './model/workgroup-change-host.vue'
export default {
	data() {
		return {
			loading: false,
			detail: {
				currentTab: this.$route.query.type || 'ecs',
				totalPage: 1,
				currentPage: 1,
				info: {},
				list: [],
				batchDel: '',
				members: [],
				isHaveNet: false,
				groups: [],
			},
			clusterIds: [],
			clusterList: {},
			currentRightPanel: null,
			rightPanelData: null,
		}
	},
	computed: {
		attrText() {
			return this.getTranslateText()
		},
	},
	created() {
		this.getWorkGroupDetail()
		this.onRouteChange()
	},
	methods: {
		// 提取翻译文本
		getTranslateText() {
			return {
				servers: this.$gettext('Servers'),
				dataBase: this.$gettext('DataBases'),
				members: this.$gettext('Member'),
				group: this.$gettext('Group'),
				name: this.$gettext('Name'),
				cluster: this.$gettext('Cluster'),
				loginUsername: this.$gettext('Login Username'),
				os: this.$gettext('OS'),
				action: this.$gettext('Action'),
				Specification: this.$gettext('Specification'),
				dataBaseName: this.$gettext('Database Name'),
				ipConnect: this.$gettext('IP/Connection String'),
				type: this.$gettext('Type'),
				email: this.$gettext('Email'),
				administrator: this.$gettext('administrator'),
				ordinary: this.$gettext('Ordinary Member'),
				defaultWorkgroup: this.$gettext('default workgroup'),
				selectCluster: this.$gettext('Select Cluster'),
				selectInstance: this.$gettext('Select Resource'),
				selectedInstance: this.$gettext('Selected Instance'),
				selectedDatabase: this.$gettext('Selected Database'),
				hostName: this.$gettext('Host name / IP'),
				account: this.$gettext('Account'),
			}
		},
		// 获取工作组资源详情
		getWorkGroupDetail() {
			let params = {
				id: this.$route.params.id,
			}
			this.$store.dispatch(STORE_CONST.WORKGROUP.GET_WORKGROUP_DETAIL, params).then((res) => {
				console.log(res, 'res')
				this.detail.info = res
				if (!this.detail.info.network_id) {
					this.detail.isHaveNet = true
				}
			})
		},
		// 获取工作组资源列表
		getWorkGroupList(page) {
			this.detail.currentPage = page || 1
			this.loading = true
			let params = {
				id: this.$route.params.id,
				params: {
					page: page || 1,
					type: this.$route.query.type,
				},
			}
			this.$store.dispatch(STORE_CONST.WORKGROUP.LIST_WORKGROUP_RESOURCE, params).then((res) => {
				this.detail.totalPage = res.total
				this.detail.list = res.objects
				this.loading = false
			})
		},
		// 获取工作组成员列表
		getMemberList(page, total) {
			let params = {
				id: this.$route.params.id,
				data: {
					page: page || 1,
				},
			}
			if (total) {
				params.data.total = total
			}
			this.loading = true
			this.$store.dispatch(STORE_CONST.WORKGROUP.GET_MEMBER_LIST, params).then(
				(res) => {
					this.detail.members = res.objects
					this.detail.totalPage = res.total
					this.detail.currentPage = res.page
					this.loading = false
				},
				() => {
					this.loading = false
				},
			)
		},
		// 获取工作组群组列表
		getGroupList(page, total) {
			let params = {
				id: this.$route.params.id,
				data: {
					page: page || 1,
				},
			}
			if (total) {
				params.data.total = total
			}
			this.loading = true
			this.$store.dispatch(STORE_CONST.WORKGROUP.GET_GROUP_LIST, params).then(
				(res) => {
					this.detail.groups = res.objects
					this.detail.totalPage = res.total
					this.detail.currentPage = res.page
					this.loading = false
				},
				() => {
					this.loading = false
				},
			)
		},

		// 删除工作组资源 成员
		batchDel(row, id) {
			this.$confirm(this.$gettext('Are you sure to delete selected?'), this.$gettext('Delete Confirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning',
			})
				.then(() => {
					row && this.$set(row, 'loading', true)
					!row && (this.loading = true)
					if (this.$route.query.type === 'member') {
						let params = {
							projectId: this.$route.params.id,
							data: {
								account_ids: id,
							},
						}
						this.$store
							.dispatch(STORE_CONST.WORKGROUP.DEL_MEMBER, params)
							.then(() => {
								this.$notify({
									type: 'success',
									message: this.$gettext('Delete successfully!'),
								})
								this.getMemberList()
							})
							.finally(() => {
								row && this.$set(row, 'loading', false)
								!row && (this.loading = false)
							})
					} else if (this.$route.query.type === 'group') {
						let params = {
							projectId: this.$route.params.id,
							data: {
								group_ids: id,
							},
						}
						this.$store
							.dispatch(STORE_CONST.WORKGROUP.DEL_GROUP, params)
							.then(() => {
								this.$notify({
									type: 'success',
									message: this.$gettext('Delete successfully!'),
								})
								this.getGroupList()
							})
							.finally(() => {
								row && this.$set(row, 'loading', false)
								!row && (this.loading = false)
							})
					} else {
						if (typeof id === 'string') {
							id = id.split(',')
						} else {
							id = [id]
						}
						let params = {
							projectId: this.$route.params.id,
							data: {
								resources: id,
							},
						}
						this.$store
							.dispatch(STORE_CONST.WORKGROUP.DEL_WORKGROUP_RESOURCE, params)
							.then(() => {
								this.$notify({
									type: 'success',
									message: this.$gettext('Delete successfully!'),
								})
								this.getWorkGroupList()
							})
							.finally(() => {
								row && this.$set(row, 'loading', false)
								!row && (this.loading = false)
							})
					}
				})
				.catch(() => {
					row && this.$set(row, 'loading', false)
					!row && (this.loading = false)
				})
		},
		// 选择批量删除的
		onSelectionChange(select) {
			if (select.length !== 0) {
				this.detail.batchDel = select.map((item) => item.id).join(',')
			} else {
				this.detail.batchDel = ''
			}
			console.log('del', this.detail.batchDel)
		},
		// 切换tab
		onTabClick(tab) {
			this.$router.push({ name: 'settingWorkgroupDetail', query: { type: tab.name } })
			this.detail = Object.assign({}, this.detail, {
				currentTab: this.$route.query.type || 'ecs',
				batchDel: '',
				currentPage: 1,
			})
			this.$refs.memberTable.clearSelection()
			this.$refs.groupTable.clearSelection()
			console.log('this.detail.batchDel---', this.detail.batchDel)
		},
		// route change
		onRouteChange() {
			if (this.$route.query.type === 'member') {
				this.getMemberList()
			} else if (this.$route.query.type === 'group') {
				this.getGroupList()
			} else {
				this.getWorkGroupList()
			}
		},
		// 分页
		onChangePage(page) {
			if (this.$route.query.type === 'group') {
				this.getGroupList(page, this.detail.totalPage)
			} else if (this.$route.query.type === 'member') {
				this.getMemberList(page, this.detail.totalPage)
			} else {
				this.getWorkGroupList(page)
			}
		},
		// 关闭侧滑回调
		onClosePanel() {
			this.currentRightPanel = null
			this.rightPanelData = null
		},
		// 传给侧滑的回调函数
		callback() {
			if (this.currentRightPanel === WorkgroupDistributeInstance || this.currentRightPanel === WorkgroupChangeHost) {
				return this.getWorkGroupList()
			} else if (this.currentRightPanel === WorkgroupAddGroup) {
				return this.getGroupList()
			} else {
				return this.getMemberList()
			}
		},
		// 修改主机
		batchChange(row) {
			console.log('修改主机')
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'WorkgroupChangeHost' ? 0 : 300
			this.currentRightPanel = WorkgroupChangeHost
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = row || []
				}, time)
			})
		},
		// 显示查看群组成员信息
		onShowWorkgroupViewGroup(row) {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'WorkgroupViewGroup' ? 0 : 300
			this.currentRightPanel = WorkgroupViewGroup
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = row || []
				}, time)
			})
		},
		// 显示分配群组
		onShowWorkgroupAddGroup(row) {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'WorkgroupAddGroup' ? 0 : 300
			this.currentRightPanel = WorkgroupAddGroup
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = row || []
				}, time)
			})
		},
		// 显示分配主机
		onShowWorkgroupDistributeInstance() {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'WorkgroupDistributeInstance' ? 0 : 300
			this.currentRightPanel = WorkgroupDistributeInstance
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = []
				}, time)
			})
		},
		// 显示添加成员
		onShowWorkgroupAddMember(row) {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'WorkgroupAddMember' ? 0 : 300
			this.currentRightPanel = WorkgroupAddMember
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = row || []
				}, time)
			})
		},
		tableRowClassName(row, index) {
			if (index % 2 === 0) {
				return 'info-row'
			}
			return ''
		},
	},
	watch: {
		$route(to, from) {
			this.detail.currentTab = this.$route.query.type
			this.onRouteChange()
		},
	},
	components: {
		WorkgroupDistributeInstance,
		WorkgroupAddMember,
		WorkgroupViewGroup,
		WorkgroupAddGroup,
		WorkgroupChangeHost,
	},
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import '../../assets/css/variable';

.workgroup-wrapper {
	.el-table-column--selection {
		.cell {
			padding-left: 11px;
			padding-right: 14px;
		}
	}
}

.add-ssk {
	height: 60px;
	line-height: 60px;
	padding: 0 15px;
	background-color: #fff;
	border: 1px solid $border-color;
	border-bottom: none;
	.el-button--text {
		color: $textColor;
		&:hover {
			color: $mainColor;
		}
		&.is-disabled {
			color: $textColor;
		}
	}
}

.table-wrapper {
	padding: 0 20px;
}

.el-button.is-loading:before {
	background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// workgroup-detail.vue?983d8522